import BaseListPresenter from "../../../../base/BaseListPresenter";

class UnlockingListPresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    upsertUseCase,
    deleteObjectUseCase,
  ) {
    super(
      view,
      findObjectUseCase,
      countObjectUseCase,
      upsertUseCase,
      deleteObjectUseCase,
    );
    this.upsertUseCase = upsertUseCase;
    this.deleteObjectUseCase = deleteObjectUseCase;
  }

  init() {
    const user = this.view.getCurrentUser();
    console.log("user", user);
    this.limit = 20;
    this.where = {
      $or: [
        { approverName: { $exists: true, $eq: user?.id } },
        { "requestor.id": { $exists: true, $eq: user?.id } },
      ],
      ...this.filterDate,
    };

    // If the user is an admin, allow all records
    if (user?.roles[0]?.id === "admin") {
      this.where = {
        ...this.filterDate,
      };
    }

    this.search = {};
    this.filter = {};
    this.filterDate = {};
    this.include = ["all"];
    this.keys = undefined; // if keys are specified, only those keys will be returned
    this.sort = { createdAt: -1 };
    this.progress = true;
    this.reset();
  }

  async getObjects() {
    this.showProgress();
    this.reset();
    await this.countObjects();
    await this.findObjects();
    this.hideProgress();
  }

  createQuery() {
    const skip = (this.current - 1) * this.limit;
    const query = {
      limit: this.limit,
      skip: skip,
      where: {
        ...this.where,
        ...this.search,
        ...this.filter,
        ...this.filterDate,
      },

      include: this.include,
    };
    if (this.sort) {
      query.sort = this.sort;
    }
    const keys = this.keys || this.view.getKeys() || [];
    if (keys.length > 0) {
      query.keys = keys;
    }
    return query;
  }

  async findObjects() {
    const collection = this.view.getCollectionName();
    const query = this.createQuery();

    try {
      this.findObjectUseCase.abort();
      const objects = await this.findObjectUseCase.execute(collection, query);
      this.objects = this.objects.concat(objects);
      this.view.setTotal(this.objects.length);
      this.view.setObjects(this.objects);
    } catch (error) {
      this.view.showError(error);
    }
  }

  onClickViewItem(index) {
    const objectId = this.objects[index].id;
    this.view.navigateTo(`${objectId}`);
  }

  onDate(event) {
    this.filterDate = this.formatDate(event);
    this.getObjects();
  }

  formatDate(dateString) {
    const date = new Date(dateString);

    // 1) Build “start of day” → 2025-06-02T00:00:00.000Z
    const startOfDay = new Date(date);
    startOfDay.setUTCHours(0, 0, 0, 0);

    // 2) Build “end of day” →   2025-06-02T23:59:59.999Z
    const endOfDay = new Date(date);
    endOfDay.setUTCHours(23, 59, 59, 999);

    // Now use those ISO strings in your query:
    this.where = {
      createdAt: {
        $gte: startOfDay.toISOString(),
        $lte: endOfDay.toISOString(),
      },
    };
  }

  formatDateToISO(date) {
    return date.toISOString();
  }

  // searchName(search) {
  //   this.reset();
  //   this.search = search.$or[0];
  //   console.log("This.search", this.search);
  //   this.getObjects();
  // }

  searchName(search) {
    this.reset();

    // Handle the nested $or structure
    if (search && search.$or && search.$or[0]) {
      this.search = search.$or[0];
    } else {
      this.search = {};
    }

    console.log("This.search", this.search);
    this.getObjects();
  }

  searchSubmit(where, merge) {
    this.presenter.searchSubmit(where, merge);
  }

  searchStatus(search) {
    this.reset();
    if (search && search.$or && search.$or[0]) {
      this.search = search.$or[0];
    } else {
      this.search = search;
    }
    this.getObjects();
  }

  searchNumberSubmit(search) {
    this.reset();
    if (search && search.$or && search.$or[0]) {
      this.search = search.$or[0];
    } else {
      this.search = search;
    }
    this.getObjects();
  }
}

export default UnlockingListPresenter;
